import { TFunction } from 'core/i18n/i18n';

export const OPTIONAL_LABEL_KEY = 'app.label.with-optional';

export const withOptionalLabel = (t: TFunction, label: string, optional: boolean = true): string =>
    optional ? t(OPTIONAL_LABEL_KEY, { label }) : label;
